// UI Constants
// Centralized configuration for consistent spacing, sizing, and timing across the application

// Timing constants (milliseconds)
export const TIMING = {
  // Debounce delays
  LINK_DETECTION_DEBOUNCE: 320,
  LINK_PREVIEW_DEBOUNCE: 350,
  
  // Animation delays
  POPUP_CLOSE_DELAY: 150,
  
  // Transition durations
  POPUP_TRANSITION: 200,
} as const;

// Spacing constants (pixels)
export const SPACING = {
  // Popup positioning
  POPUP_OFFSET: 8,
  POPUP_PADDING: 12,
  
  // Mobile viewport adjustments
  MOBILE_BREAKPOINT: 768,
  MOBILE_POPUP_MAX_WIDTH: 320,
  MOBILE_POPUP_MARGIN: 16,
  
  // Desktop popup sizing
  DESKTOP_POPUP_MAX_WIDTH: 400,
} as const;

// Sizing constants (pixels)
export const SIZING = {
  // Popup dimensions
  POPUP_HEIGHT: 120,
  POPUP_ABOVE_OFFSET: 128,
  
  // Image compression
  MAX_IMAGE_WIDTH: 1920,
  MAX_IMAGE_HEIGHT: 1080,
  MAX_FILE_SIZE_MB: 2,
  IMAGE_COMPRESSION_QUALITY: 0.85,
  
  // Attachment limits
  MAX_ATTACHMENTS: 2,
} as const;

// Character limits
export const LIMITS = {
  FARCASTER_MAX_CHARS: 320,
} as const;

// API payload limits
export const API_LIMITS = {
  MAX_PAYLOAD_SIZE_MB: 12,
} as const;

// CSS custom property values
export const CSS_VALUES = {
  LINK_HIGHLIGHT_OPACITY: 25, // 25% of action color
} as const;
